
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import * as Pedidos from '@lib/Ventas/Pedidos';
    import { RespuestaPredefinida } from '@lib/Preguntas/RespuestaPredefinida';
    import { Controlador as Model, ControladorDeRespuestasPredefinidas, Buscador } from './respuestas-predefinidas-controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeRespuestasPredefinidas { return Model; }

        @Prop()
        public IdEditando: number;

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => { this.Abierto = true; } );
        }

        public Item: RespuestaPredefinida = new RespuestaPredefinida();

        public async guardar()
        {
            if ( !this.Item.Respuesta || !this.Item.Titulo || !this.Item.Color )
                return;
            let e = false;
            this.Estado = 'guardando';
            if ( this.Item.Existe )
            {
                e = await this.Controlador.editar( this.Item );
            } else
            {
                e = await this.Controlador.crear( this.Item );
            }

            if ( e )
            {
                this.Estado = 'guardado';
                this.Abierto = false;
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
            }
            else
            {
                this.Estado = 'error-al-guardar';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }

        }

        public async buscar()
        {

            this.Estado = 'cargando';
            if ( this.IdEditando )
            {
                this.Item = await RespuestaPredefinida.create( this.IdEditando );
            } else
            {
                this.Item = new RespuestaPredefinida();
            }
            if ( !this.Item )
            {
                this.Estado = 'error';
            } else {
                this.Estado = 'ok';
            }
        }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        async onAbierto()
        {
            if ( this.Abierto )
            {
                await this.buscar();
            }
        }
        public Estado: 'cargando' | 'guardando' | 'guardado' | 'error-al-guardar' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';

    }
